import React from "react";
import { Star } from "lucide-react";

export function Stars({ value = 0, size = 12 }) {
  const full = Math.round(value);
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`${value} stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          strokeWidth={1.5}
          className={i <= full ? "fill-amber1 text-amber1" : "text-border1"}
        />
      ))}
    </span>
  );
}

export function TierBadge({ tier }) {
  if (tier === "built_in") {
    return (
      <span className="font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 border border-tier_builtin bg-tier_builtin/20 text-tier_builtin_tx" data-testid="tier-badge-built_in">
        Built-in
      </span>
    );
  }
  if (tier === "demo") {
    return (
      <span className="font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 border border-tier_demo bg-tier_demo/20 text-tier_demo_tx demo-stripe" data-testid="tier-badge-demo">
        Official Demo
      </span>
    );
  }
  return (
    <span className="font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 border border-tier_comm bg-tier_comm/20 text-tier_comm_tx" data-testid="tier-badge-community">
      Community
    </span>
  );
}

export function VerifiedBadge({ title = "Verified creator" }) {
  // Engineered checkmark — inline SVG (not default lucide) to feel distinctive
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" title={title} aria-label={title} data-testid="verified-badge">
      <path d="M12 2l2.39 2.4 3.33-.3.3 3.33L20.4 9.6 19.1 12l1.3 2.39-2.38 2.17-.3 3.33-3.33-.3L12 22l-2.39-2.4-3.33.3-.3-3.33L3.6 14.4 4.9 12 3.6 9.6l2.38-2.17.3-3.33 3.33.3L12 2z" fill="#FFC300" />
      <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="#000" strokeWidth="2" fill="none" strokeLinecap="square" />
    </svg>
  );
}
